import React from 'react';
import { FormattedMessage } from 'react-intl';

import Styled from 'styled';
import SVGIcon from 'lib/images/svg-icon/svg-icon';

import newArticle from 'four-nets/icons/svg/icon_new-article.svg';

import _ from './submit-button.graphql';
import { PostType } from './submit-button.graphql.types';

import defaultStyles from './submit-button.scss';

export interface Props extends React.ButtonHTMLAttributes<HTMLButtonElement> {
    styles: typeof defaultStyles;
    postType?: PostType;
    disabled: boolean;
}

class SubmitButton extends React.PureComponent<Props> {
    render() {
        const { styles, postType, disabled, onClick, ...rest } = this.props;

        return (
            <button
                type={onClick ? 'button' : 'submit'}
                className={`${styles.button} ${postType === 'POST_ALBUM' ? styles.album : ''}`}
                disabled={disabled}
                onClick={onClick}
                {...rest}
            >
                <SVGIcon style={{ image: styles.buttonIcon }} src={newArticle} />
                {this.props.children ||
                    (postType === 'POST_ALBUM' ? (
                        <FormattedMessage id='CREATE_ALBUM_AND_START_ADDING_PHOTOGRAPHS' values={{ gender: 'v' }} />
                    ) : (
                        <FormattedMessage id='ADD_GROUP_POST' />
                    ))}
            </button>
        );
    }
}

export default Styled(defaultStyles)(SubmitButton);
